"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializationServiceImpl = void 0;
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
class InitializationServiceImpl extends api_shared_js_1.ServiceImplBase {
    get serviceName() {
        return "InitializationService" /* ExtensionsServiceNames.InitializationService */;
    }
    initializeDashboardExtensionsAsync(isExtensionDialog, contextMenuIds) {
        const params = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'initializeDashboardExtensionsAsync',
            [api_internal_contract_js_1.ParameterId.ExtensionContextMenuIds]: contextMenuIds,
            [api_internal_contract_js_1.ParameterId.IsExtensionDialog]: isExtensionDialog,
        };
        return this.execute(api_internal_contract_js_1.VerbId.InitializeExtension, params).then((response) => {
            // TODO - Validate return value
            const result = response.result;
            return result;
        });
    }
}
exports.InitializationServiceImpl = InitializationServiceImpl;
//# sourceMappingURL=InitializationServiceImpl.js.map